<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="top_box"
			>
				<div class="left">Product Center</div>
				<div class="right">
					{{ productTypeName ? productTypeName : 'All Product' }}
					<!-- <span @click="filterShow = true;">
						Screen&ensp;<van-icon :name="filterShow ? 'arrow-up' : 'arrow-down'" color="#999999" size="18px" style="top: 2.5px;" />
					</span>
					<span @click="resetSearch">Reset</span> -->
				</div>
			</div>
			<!--banner-->
			<div
				ref="myElement"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/product/banner_h501.webp" />
			</div>
			<!--banner-->
			<div class="list_main">
				<div v-if="productsList.length > 0">
					<div class="list_box">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							v-for="(value, index) in productsList"
							:key="index"
							class="list_el"
							@click="goInfo(value)"
						>
							<img :src="webUrl + value.thumb" />
							<div class="tit_box">
								<div class="tit">{{ value.name }}</div>
							</div>
						</div>
					</div>
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						class="page_box"
					>
						<el-pagination
							:small="false"
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="12"
							:pager-count="5"
							@current-change="pageChange"
						>
						</el-pagination>
					</div>
				</div>
				<div
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
					v-if="productsList.length == 0 && !listLoading"
				>
					<van-empty image="search" description="No Data" />
				</div>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--筛选弹框-->
		<van-popup
			v-model="filterShow"
			position="top"
			:style="{ width: '100%', height: 'auto' }"
		>
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="filter_box"
			>
				<!--导航-->
				<navBox></navBox>
				<!--导航-->
				<div class="top_box">
					<div class="left">Product Center</div>
					<div class="right" @click="filterShow = false;">
						Screen&ensp;<van-icon :name="filterShow ? 'arrow-up' : 'arrow-down'" color="#999999" size="18px" style="top: 2.5px;" />
					</div>
				</div>
				<div class="list_box">
					<div v-if="solutionList.length > 0" class="list_el">
						<div class="title">Solution: </div>
						<div class="list_el_main">
							<div class="all">
								<div :class="isAll1 == 1 ? 'actived' : ''" @click="checkAll(1)">All Solution</div>
							</div>
							<div
								v-for="(value, index) in solutionList"
								:key="index"
								class="list_el_el"
								:class="value.is_checked == 1 ? 'actived' : ''"
								@click="checkStatus(1, value)"
							>{{ value.title }}</div>
						</div>
					</div>
					<div v-if="productsTypeList.length > 0" class="list_el">
						<div class="title">Categorie: </div>
						<div class="list_el_main">
							<div class="all">
								<div :class="isAll2 == 2 ? 'actived' : ''" @click="checkAll(2)">All Categorie</div>
							</div>
							<div
								v-for="(value, index) in productsTypeList"
								:key="index"
								class="list_el_el"
								:class="value.is_checked == 1 ? 'actived' : ''"
								@click="checkStatus(2, value)"
							>{{ value.title }}</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>
		<!--筛选弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { productSelectList, productList } from '@/api/public'  //产品筛选、列表
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			inputVal: '',
			page: 1,
			total: 0,
			listLoading: true,
			filterShow: false,
			solutionList: [],  //解决方案
			productsTypeList: [],  //产品分类
			productsList: [],  //产品列表
			solutionId: [],
			cateId: [],
			isAll1: null,
			isAll2: null,
			productTypeName: null,
			webUrl: UPURL,
			lang: sessionStorage.getItem('lang')
		}
	},
	created(){
		let that = this;
		if(that.$route.query.scenarios_ids) {
			that.solutionId.push(that.$route.query.scenarios_ids);
		}
		if(that.$route.query.cate_ids) {
			that.cateId.push(that.$route.query.cate_ids);
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		//请求筛选条件
		// that.getFilter();
		//请求产品列表
		that.getList();
	},
	watch: {
		//
	},
	methods: {
		//重置筛选条件
		resetSearch() {
			let that = this;
			that.solutionId = [];
			that.cateId = [];
			that.isAll1 = null;
			that.isAll2 = null;
			that.inputVal = '';
			that.page = 1;
			that.getFilter();
			that.getList();
		},
		//点击查看详情
		goInfo(value) {
			let that = this;
			that.$router.push({ name: 'ProductInfo', params: { productInfoId: value.id + '.html' } });
		},
		//产品列表
		getList(type) {
			let that = this;
			that.listLoading = true;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			productList({
				keyword: that.inputVal,
				cate_ids: that.cateId.join(','),
				scenarios_ids: that.solutionId.join(','),
				page: that.page,
				page_size: 12,
				language: that.lang
			}).then(res => {
				that.productsList = res.data.productlist.data;
				that.total = res.data.productlist.total;
				that.productTypeName = res.data.catename;
				that.listLoading = false;
				that.$toast.clear();
				that.filterShow = false;
				if(type) {
					//滚动到列表顶部
					that.$refs.myElement.scrollIntoView({ behavior: 'smooth' });
				}
			});
		},
		//全选
		checkAll(value) {
			let that = this;
			switch(value) {
				case 1:
					if(!that.isAll1) {
						that.isAll1 = value;
						that.solutionId = [];
						that.solutionList.forEach((value, index) => {
							value.is_checked = 1;
							that.solutionId.push(value.id);
						});
					}else {
						that.isAll1 = null;
						that.solutionId = [];
						that.solutionList.forEach((value, index) => {
							value.is_checked = 0;
						});
					}
				break;
				case 2:
					if(!that.isAll2) {
						that.isAll2 = value;
						that.cateId = [];
						that.productsTypeList.forEach((value, index) => {
							value.is_checked = 1;
							that.cateId.push(value.id);
						});
					}else {
						that.isAll2 = null;
						that.cateId = [];
						that.productsTypeList.forEach((value, index) => {
							value.is_checked = 0;
						});
					}
				break;
			}
			// console.log(that.solutionId);
			// console.log(that.cateId);
			that.getList();
		},
		//切换筛选条件
		checkStatus(type, value) {
			let that = this;
			that.solutionId = [];
			that.cateId = [];
			value.is_checked = !value.is_checked;
			that.solutionList.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.solutionId.push(value.id);
				}
			});
			that.productsTypeList.forEach((value, index) => {
				if(value.is_checked == 1) {
					that.cateId.push(value.id);
				}
			});
			if(that.solutionId.length == that.solutionList.length) {
				that.isAll1 = 1;
			}else {
				that.isAll1 = null;
			}
			if(that.cateId.length == that.productsTypeList.length) {
				that.isAll2 = 2;
			}else {
				that.isAll2 = null;
			}
			// console.log(that.solutionId);
			// console.log(that.cateId);
			that.getList();
		},
		//筛选条件
		getFilter() {
			let that = this;
			productSelectList({
				language: that.lang,
				cate_ids: that.cateId.join(','),
				scenarios_ids: that.solutionId.join(','),
			}).then(res => {
				that.solutionList = res.data.scenarios_list;
				that.productsTypeList = res.data.cate_list;
			});
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList(true);
		}
	}
}
</script>

<style lang="less" scoped>
.filter_box{
	color: #333333;
	.list_box{
		padding: 0px 16px 20px 16px;
		.list_el{
			padding: 10px 0;
			.list_el_main{
				.list_el_el.actived{
					border: 1px solid #C8000A;
					color: #C8000A;
				}
				.list_el_el{
					display: inline-block;
					margin: 0 15px 10px 0;
					padding: 6px 12px;
					border: 1px solid #EEEEEE;
					border-radius: 8px;
					font-size: 12px;
				}
				.all{
					padding-top: 12px;
					div.actived{
						border: 1px solid #C8000A;
						color: #C8000A;
					}
					div{
						display: inline-block;
						margin: 0 15px 10px 0;
						padding: 6px 12px;
						border: 1px solid #EEEEEE;
						border-radius: 8px;
						font-size: 12px;
					}
				}
			}
			.title{
				font-weight: bold;
			}
		}
	}
	.top_box{
		display: flex;
		padding: 16px 16px 10px 16px;
		.right{
			font-size: 14px;
		}
		.left{
			flex: 1;
			font-size: 20px;
			font-weight: bold;
		}
	}
}
.main_box{
	color: #333333;
	.list_main{
		padding: 30px 16px 50px 16px;
		.list_box{
			overflow: hidden;
			.list_el{
				display: inline-table;
				width: 48%;
				margin: 0 1% 2% 1%;
				border: 1px solid #B8B8B8;
				.tit_box{
					padding: 15px 10px 20px 10px;
					.tit{
						height: 65px;
						font-size: 12px;
						line-height: 1.8;
					}
				}
				img{
					width: 100%;
					object-fit: cover;
				}
			}
		}
	}
	.top_box{
		display: flex;
		align-items: center;
		padding: 16px;
		.right{
			flex: 1;
			font-size: 14px;
			text-align: right;
			padding-left: 10px;
			span{
				display: inline-block;
				margin-left: 10px;
			}
		}
		.left{
			width: auto;
			white-space: pre;
			font-size: 20px;
			font-weight: bold;
		}
	}
	//分页
	.page_box{
		padding-top: 40px;
		text-align: center;
	}
	//轮播
	.banner_box{
		img{
			width: 100%;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #C8000A !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>